import { render, staticRenderFns } from "./SendRequestEquipmentResources.vue?vue&type=template&id=9c80d7a2&scoped=true"
import script from "./SendRequestEquipmentResources.vue?vue&type=script&lang=js"
export * from "./SendRequestEquipmentResources.vue?vue&type=script&lang=js"
import style0 from "./SendRequestEquipmentResources.vue?vue&type=style&index=0&id=9c80d7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c80d7a2",
  null
  
)

export default component.exports